import { render, staticRenderFns } from "./TheCrud.vue?vue&type=template&id=70e45c12&scoped=true"
import script from "./TheCrud.vue?vue&type=script&lang=js"
export * from "./TheCrud.vue?vue&type=script&lang=js"
import style0 from "./TheCrud.vue?vue&type=style&index=0&id=70e45c12&prod&scoped=true&lang=css"
import style1 from "./TheCrud.vue?vue&type=style&index=1&id=70e45c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e45c12",
  null
  
)

export default component.exports